<div class="header-container"
     [class.left]="position === 'normal'"
     [class.right]="position === 'inverse'">
  <div class="logo-containter">
    <a (click)="toggleSidebar()" href="#" class="navigation">
      <nb-icon icon="menu-2-outline"></nb-icon>
    </a>
    <div class="logo-wrapper" (click)="goToHome()"><img src="/assets/images/logo.png" class="logo"/></div>
  </div>
</div>

<div class="header-container">
  <!-- defer to prevent loading until needed -->
  @defer (when $displayUsine()) {
    @if ($displayUsine()) {
      <nb-action class="usine-ctx">
        <select
          nbTooltip="selectionnez l'usine sur laquelle vous souhaitez travailler"
          nbTooltipIcon="hash-outline"
          nbTooltipPlacement="bottom"
          [ngModel]="usineCtxStore.getUsine()?.id"
          (ngModelChange)="usineCtxStore.setUsineById($event)"
          [compareWith]="compareUsines"
          class="form-select">
          <option *ngFor="let option of listeUsine" [ngValue]="option.value">
            {{ option.name }}
          </option>
        </select>
      </nb-action>
    }
  }

  <nb-actions
    size="medium"
    [class.right]="position === 'normal'"
    [class.left]="position === 'inverse'">
    <nb-action disabled></nb-action>
    <nb-action *nbIsGranted="['view', 'user']">
      <nb-user class="click" [nbContextMenu]="userMenu" [name]="getNomComplet()"></nb-user>
    </nb-action>
    <nb-action *ngIf="boutonFiltreService.isVisible" class="control-item click" icon="search-outline"
               (click)="clickOnFilterButton()"></nb-action>
  </nb-actions>
</div>
